const wrapper = (promise) => promise.then((data) => [null, data]).catch((error) => [error, null]);

const asyncForEach = async function (array, callback) {
  for (let index = 0; index < array.length; index++) {
    const [error, results] = await wrapper(callback(array[index], index, array));
    if (error) return Promise.reject(error);
  }
  return Promise.resolve();
};

module.exports = {
  wrapper,
  asyncForEach,
};
